// Inject the app-owned opt-in so package and app list gates agree.
// No imports: the flags door must load in bare Node.

export interface SessionFlagsConfig {
  // Reads flag AND opt-in. Called unconditionally; the implementation must be a hook.
  useIsManagedReleaseLayoutOptedIn: () => boolean;
}

const useNotOptedIn = (): boolean => false;

let config: SessionFlagsConfig = {
  useIsManagedReleaseLayoutOptedIn: useNotOptedIn,
};
let isConfigured = false;
let hasReadBeforeConfiguration = false;
let hasReportedLateConfiguration = false;

/** Set once at app bootstrap. Before that the seam answers `false`. */
export const configureSessionFlags = (next: SessionFlagsConfig): void => {
  // Detects late configuration only: a missing wiring import still reads false silently.
  if (hasReadBeforeConfiguration && !isConfigured && !hasReportedLateConfiguration) {
    hasReportedLateConfiguration = true;
    // eslint-disable-next-line no-console -- headless door, no app logger
    console.error(
      'configureSessionFlags ran after the session list gate was read, so components that already rendered used the default hook. Import the session data wiring before rendering session UI.'
    );
  }
  config = next;
  isConfigured = true;
};

/** The injected managed-release opt-in read, or `false` when unconfigured. */
export const useManagedReleaseLayoutOptedIn = (): boolean => {
  if (!isConfigured) hasReadBeforeConfiguration = true;
  return config.useIsManagedReleaseLayoutOptedIn();
};
